export default __webpack_public_path__ + "static/poster-96b3d90efb2818a7642e456347a33f4d.png";